import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@icc/shared';
import { environment } from '../../environments/environment';

@Component({
  selector: 'icc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  year =  new Date().getFullYear();
  copyright = 'IC COMPLEX';
  appVersion = '';
  hideICC = false;

  constructor(
    private configService: ConfigService,
  ) {}

  ngOnInit(){
    const appConfig = this.configService.config;
    this.copyright = appConfig?.theme?.copyright ? appConfig.theme.copyright : ( appConfig?.env?.appName?.length ? appConfig.env.appName : 'IC COMPLEX');
    this.appVersion = environment?.appVersion ? environment.appVersion : '';
    this.hideICC = appConfig?.config?.Theme?.hideICC;
  }


}
